import { render, staticRenderFns } from "./IndexBlock.vue?vue&type=template&id=46ba7a72&scoped=true&"
import script from "./IndexBlock.vue?vue&type=script&lang=js&"
export * from "./IndexBlock.vue?vue&type=script&lang=js&"
import style0 from "./IndexBlock.vue?vue&type=style&index=0&id=46ba7a72&lang=scss&scoped=true&"
import style1 from "./IndexBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ba7a72",
  null
  
)

export default component.exports